module.exports = __webpack_public_path__ + "img/Tessellate41.73b4d8e1.jpg";